import { defineStore } from "pinia";
import { ref } from "vue";

export const useProgressStore = defineStore('progress', () => {
  const current = ref(0)

  function updateFromRoute(routeName: string) {
    switch (routeName) {
      case 'vehicle':
      case 'manual-vehicle':
        current.value = 10
        break
      case 'type':
        current.value = 30
        break
      case 'details':
        current.value = 50
        break
      case 'payment':
        current.value = 60
        break
      case 'addons':
        current.value = 70
        break
      case 'customer':
        current.value = 80
        break
      case 'confirm':
        current.value = 90
        break
      case 'finish':
        current.value = 100
        break
      default:
        addPercentage(10)
    }
  }

  function addPercentage(percentage: number) {
    const diff = 100 - current.value

    current.value += (diff / 100) * percentage
  }

  function complete() {
    current.value = 100
  }

  return { current, updateFromRoute, addPercentage, complete }
})